function applyProps(element, props) {
    return element.attr("fill", props === null || props === void 0 ? void 0 : props.fill);
}
export const drehleiter = {
    size: [35, 35],
    render: (svg) => svg.path("M1,34 L24,11 H34 V1 H24 V11"),
};
export const hebegeraet = {
    size: [20, 30],
    render: (svg) => svg.path("M1,30 v-29 h8 a5 5 0 0 0 10 0"),
};
export const bagger = {
    size: [35.5, 23],
    render: (svg) => svg.path("M1,22 l20.5,-20.5 l5,5 a5 5 0 0 0 8 8"),
};
export const bruecke = {
    size: [41, 16],
    render: (svg) => svg.path("M.5,1 l10,5 h20 l10,-5 M.5,15 l10,-5 h20 l10,5"),
};
export const raeumgeraet = {
    size: [30, 19],
    render: (svg) => svg.path("M0,9 h21 m0,-9 v14 l8,4"),
};
export const sprengmittel = {
    size: [16, 17],
    render: (svg) => svg
        .g()
        .push(svg.circle([8, 9], 1).attr("fill", "black"))
        .push(svg.circle([8, 9], 7))
        .push(svg.path("M4,2.5 l-1,-2 M11.5,2.5 l1,-2")),
};
export const beleuchtung = {
    size: [15, 20],
    render: (svg) => svg
        .g()
        .push(svg.path("M1,20 v-14 a5 5 0 0 1 10 0"))
        .push(svg.circle([11, 9], 3)),
};
export const bett = {
    size: [30, 18],
    render: (svg) => svg.path("M1,0 v18 m0,-5 h28 m0,5 v-18 m0,15 c0,-8 -28,-8 -28,0"),
};
export const verpflegung = {
    size: [17.8, 20],
    render: (svg) => svg.path("M10,10 l6.36,-6.36 a9 9 0 1 0 0 12.72 z"),
};
export const verbrauchsgueter = {
    size: [18, 24],
    render: (svg) => svg.path("M7,24 v-14 l-7,-10 h18 l-7,10 v14"),
};
export const trinkwasser = {
    size: [28, 14],
    render: (svg) => svg.path("M1,14 v-3 a7 7 0 0 1 7 -7 h20 m-15,-3 v7 m-4,-7 h8"),
};
export const brauchwasser = {
    size: [50, 17],
    render: (svg) => svg.path("M1,9 c0,-10 16,-10 16,-1 0,10 16,10 16,1 0,-10 16,-10 16,0"),
};
export const elektrizitaet = {
    size: [17, 24],
    render: (svg) => svg
        .g()
        .push(svg.path("M14.5,1 l-10,10 h10 l-10,10"))
        .push(svg.path("M4.5,21 l5,2 l-8,0 l2,-7 Z").attr("fill", "black")),
};
export const geraete = {
    size: [37, 14],
    render: (svg) => svg.path("M6,7 l25,0 m6,-6 a6 6 0 0 0 0 12 M0,1 a6 6 0 0 1 0 12"),
};
export const sprengung = {
    size: [10, 17],
    render: (svg) => svg.path("M1,1 c0,5 3,15 4,15 1,0 4,-10 4,-15 Z").attr("fill", "black"),
};
export const transport = {
    size: [30, 30],
    render: (svg) => svg
        .g()
        .push(svg.circle([15, 15], 14))
        .push(svg.path("M1,15 h28 M15,1 v28 M5,5 l20,20  M5,25 l20,-20")),
};
export const fahrzeug = {
    size: [75, 45],
    render: (svg, props) => applyProps(svg.path("M1,44 V1 Q37.5,10 74,1 V44 Z"), props),
};
export const fahrrad = {
    size: [42, 45],
    render: (svg) => svg.path("M1,21 a20 20 0 0 1 40 0 m-20,-20 v45"),
};
export const kraftrad = {
    size: [42, 45],
    render: (svg) => svg.path("M1,21 a20 20 0 0 1 40 0 m-20,-20 v45 m-10,-20 h20"),
};
export const flugzeug = {
    size: [38, 15],
    render: (svg, props) => svg
        .g()
        .push(svg.path("M19,0 v15"))
        .push(applyProps(svg.path("M5,3.5 h10 a4 4 0 0 1 0 8 h-10 a4 4 0 0 1 0 -8 Z"), props))
        .push(applyProps(svg.path("M23,3.5 h10 a4 4 0 0 1 0 8 h-10 a4 4 0 0 1 0 -8 Z"), props)),
};
export const hubschrauber = {
    size: [38, 23],
    render: (svg, props) => svg
        .g()
        .push(svg.path("M19,2 v20 m-10,0 h20"))
        .push(applyProps(svg.path("M5,1 h10 a4 4 0 0 1 0 8 h-10 a4 4 0 0 1 0 -8 Z"), props))
        .push(applyProps(svg.path("M23,1 h10 a4 4 0 0 1 0 8 h-10 a4 4 0 0 1 0 -8 Z"), props)),
};
export const beschaedigt = {
    size: [30, 30],
    render: (svg) => svg.path("M1,1 L29,29 M1,29 L29,1"),
};
export const teilzerstoert = {
    size: [30, 30],
    render: (svg) => svg.path("M9,1 L29,20 M1,20 L20,1 M1,9 L20,29 M9,29 L29,9"),
};
export const zerstoert = {
    size: [30, 30],
    render: (svg) => svg.path("M9,1 L29,20 M1,20 L20,1 M1,9 L20,29 M9,29 L29,9 M5,5 L25,25 M5,25 L25,5"),
};
export const teilblockiert = {
    size: [6, 30],
    render: (svg) => svg.path("M1,0 V30 M5,0 V30"),
};
export const blockiert = {
    size: [14, 30],
    render: (svg) => svg.path("M1,0 V30 M5,0 V30 M9,0 V30 M13,0 V30"),
};
export const entstehungsbrand = {
    size: [13, 34],
    render: (svg) => svg
        .g()
        .push(svg.clipPath("brand-clip").push(svg.path("M13,0 v34 h-12.5 Z")))
        .push(svg
        .path("M12,5 v28 h-10 l12,-33")
        .attr("clip-path", "url(#brand-clip)")
        .attr("stroke", "#cc0000")),
};
export const fortentwickelterBrand = {
    size: [23, 34],
    render: (svg) => svg
        .g()
        .push(entstehungsbrand.render(svg).attr("id", "brand"))
        .push(svg.use("#brand").attr("x", 10)),
};
export const vollbrand = {
    size: [33, 34],
    render: (svg) => svg
        .g()
        .push(entstehungsbrand.render(svg).attr("id", "brand"))
        .push(svg.use("#brand").attr("x", 10))
        .push(svg.use("#brand").attr("x", 20)),
};
export const sirene = {
    size: [30, 20],
    render: (svg) => svg.path("M2,8.5 a15 15 0 0 1 26 0 Z M15,8.5 v11.5"),
};
export const lautsprecher = {
    size: [27, 23],
    render: (svg) => svg.path("M1,3.5 l5,3 v10 l-5,3 Z m5,3 l20,-5 v20 l-20,-5 Z"),
};
export const zelt = {
    size: [30, 30],
    render: (svg) => svg.path("M13,1 l15,28 h-26 l15,-28"),
};
export const sichten = {
    size: [30, 30],
    render: (svg) => svg
        .path("M7,3 l-3,2 l3,2 Z m0,2 h16 m0,-2 l3,2 l-3,2 Z")
        .attr("fill", "black"),
};
export const veterinaerwesen = {
    size: [30, 30],
    render: (svg) => svg.path("M0,1 h5 l10,26 l10,-26 h5"),
};
export const person = {
    size: [45, 45],
    render: (svg) => svg.path("M22.5,1.5 L43.5,22.5 L22.5,43.5 L1.5,22.5 Z"),
};
export const personVerletzt = {
    size: [45, 45],
    render: (svg) => svg.path("M22.5,1.5 L43.5,22.5 L22.5,43.5 L1.5,22.5 Z M22.5,1.5 v42"),
};
export const personTot = {
    size: [45, 45],
    render: (svg) => svg.path("M22.5,1.5 L43.5,22.5 L22.5,43.5 L1.5,22.5 Z M22.5,1.5 v42 M14,10 h17"),
};
export const personVermisst = {
    size: [49, 49],
    render: (svg) => svg
        .g()
        .push(svg
        .path("M22.5,1.5 L43.5,22.5 L22.5,43.5 L1.5,22.5 Z")
        .attr("transform", "translate(2,2)"))
        .push(svg.path("M1,23 L23,1 M26,48 L48,26")),
};
export const personVerschuettet = {
    size: [45, 45],
    render: (svg) => svg.path("M22.5,1.5 L43.5,22.5 L22.5,43.5 L1.5,22.5 Z M0,1 h45"),
};
export const personGerettet = {
    size: [45, 45],
    render: (svg) => svg.path("M22.5,1.5 L43.5,22.5 L22.5,43.5 L1.5,22.5 Z M0,44 h45"),
};
export const symbole = [
    Object.assign(Object.assign({}, drehleiter), { id: "drehleiter", label: "Drehleiter" }),
    Object.assign(Object.assign({}, hebegeraet), { id: "hebegeraet", label: "Hebegerät" }),
    Object.assign(Object.assign({}, bagger), { id: "bagger", label: "Bagger" }),
    Object.assign(Object.assign({}, raeumgeraet), { id: "raeumgeraet", label: "Räumgerät" }),
    Object.assign(Object.assign({}, bruecke), { id: "bruecke", label: "Brücke" }),
    Object.assign(Object.assign({}, sprengmittel), { id: "sprengmittel", label: "Sprengmittel" }),
    Object.assign(Object.assign({}, beleuchtung), { id: "beleuchtung", label: "Beleuchtung" }),
    Object.assign(Object.assign({}, bett), { id: "bett", label: "Bett" }),
    Object.assign(Object.assign({}, verpflegung), { id: "verpflegung", label: "Verpflegung" }),
    Object.assign(Object.assign({}, verbrauchsgueter), { id: "verbrauchsgueter", label: "Verbrauchsgüter" }),
    Object.assign(Object.assign({}, trinkwasser), { id: "trinkwasser", label: "Trinkwasser" }),
    Object.assign(Object.assign({}, brauchwasser), { id: "brauchwasser", label: "Brauchwasser" }),
    Object.assign(Object.assign({}, elektrizitaet), { id: "elektrizitaet", label: "Elektrizität" }),
    Object.assign(Object.assign({}, geraete), { id: "geraete", label: "Geräte" }),
    Object.assign(Object.assign({}, sprengung), { id: "sprengung", label: "Sprengung" }),
    Object.assign(Object.assign({}, transport), { id: "transport", label: "Transport" }),
    Object.assign(Object.assign({}, fahrzeug), { id: "fahrzeug", label: "Fahrzeug" }),
    Object.assign(Object.assign({}, fahrrad), { id: "fahrrad", label: "Fahrrad" }),
    Object.assign(Object.assign({}, kraftrad), { id: "kraftrad", label: "Kraftrad" }),
    Object.assign(Object.assign({}, flugzeug), { id: "flugzeug", label: "Flugzeug" }),
    Object.assign(Object.assign({}, hubschrauber), { id: "hubschrauber", label: "Hubschrauber" }),
    Object.assign(Object.assign({}, entstehungsbrand), { id: "entstehungsbrand", label: "Entstehungsbrand" }),
    Object.assign(Object.assign({}, fortentwickelterBrand), { id: "fortentwickelter-brand", label: "Fortentwickelter Brand" }),
    Object.assign(Object.assign({}, vollbrand), { id: "vollbrand", label: "Vollbrand" }),
    Object.assign(Object.assign({}, sirene), { id: "sirene", label: "Sirene" }),
    Object.assign(Object.assign({}, lautsprecher), { id: "lautsprecher", label: "Lautsprecher" }),
    Object.assign(Object.assign({}, zelt), { id: "zelt", label: "Zelt" }),
    Object.assign(Object.assign({}, sichten), { id: "sichten", label: "Sichten, ordnen, verteilen" }),
    Object.assign(Object.assign({}, veterinaerwesen), { id: "veterinaerwesen", label: "Veterinärwesen" }),
    Object.assign(Object.assign({}, person), { id: "person", label: "Person" }),
    Object.assign(Object.assign({}, personVerletzt), { id: "person-verletzt", label: "Person verletzt" }),
    Object.assign(Object.assign({}, personTot), { id: "person-tot", label: "Person tot" }),
    Object.assign(Object.assign({}, personVermisst), { id: "person-vermisst", label: "Person vermisst" }),
    Object.assign(Object.assign({}, personVerschuettet), { id: "person-verschuettet", label: "Person verschuettet" }),
    Object.assign(Object.assign({}, personGerettet), { id: "person-gerettet", label: "Person gerettet" }),
    Object.assign(Object.assign({}, beschaedigt), { id: "beschaedigt", label: "beschädigt" }),
    Object.assign(Object.assign({}, teilzerstoert), { id: "teilzerstoert", label: "teilzerstört" }),
    Object.assign(Object.assign({}, zerstoert), { id: "zerstoert", label: "zerstört" }),
    Object.assign(Object.assign({}, teilblockiert), { id: "teilblockiert", label: "teilblockiert" }),
    Object.assign(Object.assign({}, blockiert), { id: "blockiert", label: "blockiert" }),
];
